import { css } from '@emotion/react';
import { theme } from 'global';

export const loading = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  max-width: 420px;
  padding: 16px;
  z-index: 1000;
`;

export const loginErrorAlert = css`
  margin: 0 auto;
  min-width: 320px;
  max-width: 500px;
  padding: 12px 16px;
`;

export const cacheHelper = css`
  margin: -56px auto 0;
`;

export const textButton = css`
  vertical-align: inherit;
  text-decoration: underline;
  color: inherit;
`;

export const main = css`
  flex-grow: 1;
  background-color: ${theme.colors.neutral[0]};
  width: 100%;
  padding: 2rem;
  scrollbar-gutter: stable both-edges;
  overflow-x: hidden;

  display: flex;
  flex-direction: column;
  position: relative;

  @media screen and (max-width: ${theme.breaks.lg - 1}px) {
    padding: 1rem;
  }

  @media screen and (max-width: ${theme.breaks.md - 1}px) {
    height: 100%;
    max-height: -webkit-fill-available;
  }
`;

export const fullPageComm = css`
  max-width: 480px;
  margin: 0 auto;
`;
